export default "__VITE_ASSET__BFcaATNo__"